// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Wir","inner":"_2jr4","item":"_3LZy","grid":"yWfc","flex":"_3_JC","img":"k661","overlay":"_2_sk","goto":"YCT4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/news/style.css
// module id = 178
// module chunks = 9